import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Brand";
import { Globe } from 'lucide-react';
import { LogOut } from "lucide-react";
import "../app-light.css";

export function TopShell({ nav, base, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="app-light min-h-screen bg-[#070B14]">
      <header className="sticky top-0 z-40 border-b border-slate-800/80 bg-[#070B14]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-5 py-3">
          <div className="flex items-center gap-8">
            <Brand size={34} tone="light" />
            <nav className="hidden items-center gap-1 lg:flex" data-testid="main-nav">
              {nav.map((n) => (
                <NavLink
                  key={n.to}
                  to={`${base}/${n.to}`}
                  end={n.to === ""}
                  className={({ isActive }) => `hw-nav-link ${isActive ? "hw-nav-link-active" : ""}`}
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => navigate('/')} aria-label="Public website" className="p-2 text-slate-300" data-testid="portal-public-home"><Globe size={20} /></button>
            <div className="hidden text-right sm:block">
              <div className="text-sm font-semibold text-white">{user?.name}</div>
              <div className="hw-eyebrow">{title}</div>
            </div>
            <button
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-700 bg-slate-800/60 text-slate-300 transition hover:border-rose-500/40 hover:text-rose-300"
              data-testid="logout-btn"
              aria-label="Sign out"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto border-t border-slate-800/60 px-3 py-2 lg:hidden">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={`${base}/${n.to}`}
              end={n.to === ""}
              className={({ isActive }) => `hw-nav-link whitespace-nowrap ${isActive ? "hw-nav-link-active" : ""}`}
              data-testid={`mobile-nav-${n.to || 'home'}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-[1400px] px-5 py-8">
        <Outlet />
      </main>
    </div>
  );
}
